import React from 'react'
import BigQueryExporterForm from './BigQueryExporterForm'
import SetTitle from '../utils/set_title'
import Header from '../components/Headers/Header'

export default function BigQueryExporter() {
  SetTitle('BigQuery Exporter')
  const description =
    'Permette di scaricare il dataset di uno studio keyword relativo a un progetto in un determinato periodo.'

  return (
    <Header
      iconClass="ni ni-folder-17 text-white"
      title="BigQuery Exporter"
      docLink="/docs/ranking_tools/bigquery-exporter/"
      description={description}
    >
      <BigQueryExporterForm />
    </Header>
  )
}